export enum RecurrenceType {
    EMPTY = 0,
    RETURN = 1,
    TIME = 2,
    CYCLE = 3,
    ONDEMAND = 4
}
